import React, {useCallback, useState} from 'react';

import AppModal from '../CustomModal/AppModal';
import {BottomButton} from '@buncha/components/composites/Button';
import BottomSheet from '@buncha/components/composites/bottomSheet';
import {Box} from '@buncha/components/core/view';
import {Components} from '@buncha/localization/types';
import {Dimensions} from 'react-native';
import If from '@buncha/components/conditional/If';
import ImageSection from './ImageSection';
import {Modules} from '@buncha/utils/types';
import {getWidth} from '@buncha/utils/common';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  bottomSheetOpen: boolean;
  title: string;
  subtitle: string;
  loading: boolean;
  imageList: string[];
  showCaptureModeFunc: (data?: any) => Promise<void>;
  closeBottomSheet: () => void;
  handleImageDelete: Function;
  uploadButtonHandler?: any;
  hasShowBottomButton?: boolean;
  hasDeleteModal?: boolean;
  isUPCMode?: boolean;
  showDefaultBottomButton?: boolean;
  bottomButtonTitle?: string;
  showContinueButton?: boolean;
}

const width = Number(getWidth(Dimensions.get('screen').width));

function ImageBottomSheet(props: Props) {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedUrlForDelete, setSelectedUrlForDelete] = useState('');
  const {title, body, button} =
    useGetLocale(Modules.common, Components.components) ?? {};

  const onDeleteHandler = useCallback(
    (url: string) => {
      setSelectedUrlForDelete(url);
      if (props?.hasDeleteModal) return setOpenDeleteModal(true);
      return props?.handleImageDelete(url);
    },
    [props],
  );

  return (
    <BottomSheet
      open={props?.bottomSheetOpen}
      onClose={props?.closeBottomSheet}>
      <Box style={styles.parentContainer}>
        <ImageSection
          showCaptureModeFunc={props?.showCaptureModeFunc}
          uploadLoading={props?.loading}
          title={props?.title}
          subtitle={props?.subtitle}
          imageList={props?.imageList}
          closeBottomSheet={props?.closeBottomSheet}
          handleImageDelete={onDeleteHandler}
          isUPCMode={props?.isUPCMode}
        />
        <If condition={props?.hasDeleteModal}>
          <AppModal
            isOpen={openDeleteModal}
            onClose={() => {
              setOpenDeleteModal(false);
            }}
            title={title?.deleteImage}
            subTitle={body?.deleteImage}
            topCTAHandelr={async () => {
              await props?.handleImageDelete(selectedUrlForDelete);
              setOpenDeleteModal(false);
            }}
            loading={props?.loading}
            ctaTopTitle={button?.delete}
            ctaBottomTitle={button?.cancel}
          />
        </If>
        <If
          condition={
            props?.hasShowBottomButton || props?.showDefaultBottomButton
          }>
          <BottomButton
            title={
              props?.showDefaultBottomButton
                ? props.bottomButtonTitle
                : button?.submitImages
            }
            loadingText={
              props?.showDefaultBottomButton
                ? props.bottomButtonTitle
                : button?.uploading
            }
            isLoading={props?.loading}
            disabled={props?.loading || !props?.imageList.length}
            onPress={
              props?.showDefaultBottomButton
                ? props.closeBottomSheet
                : props?.uploadButtonHandler
            }
            style={styles.bottomButton}
          />
        </If>
      </Box>
      <If condition={props?.showContinueButton}>
        <BottomButton
          style={[styles.buttonContainer, {width: width * 0.9}]}
          title={button?.continue}
          onPress={props?.closeBottomSheet}
          disabled={props?.imageList?.length <= 0 || props?.loading}
        />
      </If>
    </BottomSheet>
  );
}

export default React.memo(ImageBottomSheet);
